import { addZero } from "./addZero";
import { formatDate } from "./formatDate";
import { getRelativeDay } from "./getRelativeDay";
import { getDaysLabels } from "./getDaysLabels";
import { getMonthsLabels } from "./getMonthsLabels";

export function formatDateWithWeekDay(date, skipRelativeDay) {
	const fDate = formatDate(date);
    const dateString = `${fDate.year}-${addZero(fDate.month)}-${addZero(fDate.day)}T${addZero(fDate.hours)}:${addZero(fDate.minutes)}:00`
	date = new Date(dateString);
	
    const di = date.getDay();
    let day = null;
    let dayMonth = null;
    let dayMonthShort = null;
    let dayMonthYear = null;

	const relativeDay = skipRelativeDay ? null : getRelativeDay(date);
	if (relativeDay) {
		day = relativeDay;
		dayMonth = relativeDay;
        dayMonthShort = `${addZero(fDate.day)}.${addZero(fDate.month)}`;
		dayMonthYear = relativeDay;
	} else {
        const days =  getDaysLabels();
		const mi = date.getMonth();
        const months = getMonthsLabels();
		day = `${days[di]} ${fDate.day}`;
		dayMonth = `${day} ${months[mi]}`;
        dayMonthShort = `${addZero(fDate.day)}.${addZero(fDate.month)}`;
		dayMonthYear = `${dayMonth} ${fDate.year}`;
	}

    return {
        date: fDate.day,
        month: fDate.month,
        weekDay: di === 0 ? 7: di,
        day: `${day}`,
        dayTime: `${day} - ${fDate.time}`,
        dayMonth: `${dayMonth}`,
        dayMonthShort,
        dayMonthTime: `${dayMonth} - ${fDate.time}`,
        dayMonthYear: `${dayMonthYear}`,
        dayMonthYearShort: `${dayMonthShort}.${fDate.year}`,
        dayMonthYearTime: `${dayMonthYear} - ${fDate.time}`
    };
}
